export default __webpack_public_path__ + "static/media/GDSC Logo Mobile.99843767.png";